import React from "react";

export default function MapView() {
  return <h2>Map Page</h2>;
}
